import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as environmentActions } from "reducers/environment";

export const useBeneficiaries = () => {
    const dispatch = useDispatch();
    const [addFinalBeneficiaries, setAddFinalBeneficiaries] = useState(true);
    const [alreadyFetchShareholders, setAlreadyFetchShareholders] = useState(false);
    const shareholders = useSelector((state) => state.environment?.shareholdersBeneficiaries);

    useEffect(() => {
        if (shareholders.length === 0 && !alreadyFetchShareholders) {
            dispatch(environmentActions.listShareholdersBeneficiaries(setAlreadyFetchShareholders));
        }
    }, [addFinalBeneficiaries, alreadyFetchShareholders]);

    return { shareholders, addFinalBeneficiaries, setAddFinalBeneficiaries, setAlreadyFetchShareholders };
};

export default useBeneficiaries;
